<div class="screen-saver-wrapper"
     (click)="dismiss()"
     [class.animating]="isAnimating()"
     [class.dismissing]="isDismissing()"
     [style.transform]="'translateY(' + swipeOffset() + 'px)'">
  <div
    class="shine-overlay"
    [style.opacity]="shineOpacity()"
  ></div>

  <ion-content
    class="screensaver"
    [style.--background]="backgroundStyle()"
  >
  <ion-grid>
    <ion-row>
      <ion-col class="left-section" size="5">
        <ion-row class="row-left-section">
          @if (leftComponent()) {
            <ng-container *ngComponentOutlet="leftComponent()"></ng-container>
          }
        </ion-row>
      </ion-col>

      @if (showSwipeIndicator()) {
        <ion-col size="1" style="height: 100%;">
          <div class="swipe-up-icon">
            <ion-icon name="chevron-up"></ion-icon>
          </div>
        </ion-col>
      }

      <ion-col class="right-section" [size]="showSwipeIndicator() ? 5 : 6">
        @if (rightComponent()) {
          <ng-container *ngComponentOutlet="rightComponent()"></ng-container>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
  </ion-content>
</div>